package com.eladfinish.contract.pdf

import kotlinx.serialization.Serializable

/**
 * Request to render [tableHtml] to a PDF on the server and return the raw bytes directly
 * (unlike [com.eladfinish.contract.email.SendHtmlEmailRequest], this doesn't email anything).
 *
 * Used by the web target, where there's no local WebView/print-to-PDF API available to the
 * browser sandbox — the same Gotenberg conversion the email flow already uses is reused here.
 */
@Serializable
data class GeneratePdfFromHtmlRequest(
    val tableHtml: String,
    val fileName: String = "table.pdf",
)
